// extracted by mini-css-extract-plugin
export default {"uploadButton":"ConnectDataSourceButton_uploadButton__JZlUU"};